<template>
	<div class="modal fade" id="viewProductCost" data-bs-backdrop="static" aria-hidden="false" role="dialog" style="display: none;" data-bs-keyboard="false">
		<div class="modal-dialog modal-lg">
			<form class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title" id="backDropModalTitle">Product Cost Detail</h5>
					<div class="text-end" v-if="productCostDetail.supplier_id"> 
						<div v-if="!productCostDetail.status && !productCostDetail.cost_id">
							<span class="badge bg-label-secondary mb-1">
								Unregister Information
							</span>
						</div>
						<div v-if="productCostDetail.status == 1">
							<span class="badge bg-label-info mb-1">
								{{ statusOptions[0].name}}
							</span>
							<br/>
							<span>{{ getNotifyMessage(1) }}</span>
						</div>
						<div v-if="productCostDetail.status == 2">
							<span class="badge bg-label-warning mb-1">
									{{ statusOptions[1].name}}
							</span>
							<br/>
							<span>{{ getNotifyMessage(2) }}</span>
						</div>
						<div v-if="productCostDetail.status == 3">
							<span class="badge bg-label-danger mb-1" >
								{{ statusOptions[2].name}}
							</span>
							<br/>
							<span>{{ getNotifyMessage(3) }}</span>
						</div>
						<div v-if="productCostDetail.status == 4">
							<span class="badge bg-label-success mb-1">
								{{ statusOptions[3].name}}
							</span>
							<br/>
							<span>{{ getNotifyMessage(4) }}</span>
						</div>
						<div v-if="productCostDetail.status == 5">
							<span class="badge bg-label-primary mb-1">
								{{ statusOptions[4].name}}
							</span>
							<br/>
							<span>{{ getNotifyMessage(5) }}</span>
						</div>
					</div>
					<!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
				</div>
				<div class="modal-body" v-if="productCostDetail">
					<h5 class="pb-2 border-bottom mb-3"></h5>
					<div class="info-container my-2">
						<div class="col-sm-12 my-2">
							<span class="fw-bold me-2">Issue Date: </span>
							<span>{{ formatDate(productCostDetail.issue_date) }}</span>
						</div>
						<div class="col-sm-12 my-2" v-if="productCostDetail.supplier_information">
							<span class="fw-bold me-2">Supplier Name: </span>
							<span>
								<a class="me-1" 
									data-bs-toggle="collapse" 
									href="#collapseSupplierInfoReceiving" 
									role="button" 
									aria-expanded="true" 
									aria-controls="collapseExample"
								>
								<span class="me-3">{{ productCostDetail.supplier_information.partner_name }}</span>
							</a>
							</span>
						</div>
						<div class="col-sm-12 my-2" v-if="productCostDetail.supplier_information">
							<div class="collapse" id="collapseSupplierInfoReceiving">
								<div class="border">
									<div class="alert mb-1" role="alert">
										<span class="alert-heading fw-bold">PAYMENT INFORMATION</span>
										<div class="row mt-3">
											<div class="col-md-3">
												<span v-if="productCostDetail.supplier_information.has_deposit == 1">HAS DEPOSIT</span>
												<span v-else>NO DEPOSIT</span>
											</div>
											<div class="col-md-3" v-if="productCostDetail.supplier_information.has_deposit == 1">
												<span class="me-1">Deposit: {{ productCostDetail.supplier_information.percent_deposit }}</span>
												<span>%</span>
											</div>
											<div class="col-md-3" v-if="productCostDetail.supplier_information.has_deposit == 1">
												<span class="me-1">Balance: {{ productCostDetail.supplier_information.percent_balance }}</span>
												<span>%</span>
											</div>
										</div>
										<div class="row mt-2">
											<div class="col-md-3">
												<span>Payment Method: </span>
												<span>{{ getPaymentName(productCostDetail.supplier_information.payment_method) }}</span>
											</div>
											<div class="col-md-3">
												<span>Term: </span>
												<span class="me-1">{{ productCostDetail.supplier_information.term }}</span>
												<span>days</span>
											</div>
											<div class="col-md-3">
												<span>Closing Time: </span>
												<span>{{ getClosingTime(productCostDetail.supplier_information.closing_time) }}</span>
											</div>
											<div class="col-md-3" v-if="productCostDetail.supplier_information.closing_time == 7">
												<span>On Exact Date: </span>
												<span>{{ productCostDetail.supplier_information.exact_date }}</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-sm-12 my-2">
							<span class="fw-bold me-2">Supplier Code: </span>
							<span>{{ productCostDetail.supplier_code }}</span>
						</div>
						<div class="col-sm-12 my-2">
							<span class="fw-bold me-2">Category: </span>
							<span>{{ productCostDetail.category_cost_name }}</span>
						</div>
						<div class="col-sm-12 my-2">
							<span class="fw-bold me-2">Supplier Invoice No: </span>
							<span>{{ productCostDetail.supplier_inv_no }}</span>
						</div>
						<div class="col-sm-12 my-2">
							<span class="fw-bold me-2">Supplier Invoice Date: </span>
							<span>{{ formatDate(productCostDetail.supplier_inv_date) }}</span>
						</div>
						<div class="col-sm-12 my-3">
							<div class="table-responsive">
								<table class="table table-bordered table-hover">
									<thead class="table-light lmd-light-color">
										<tr>
											<th>Product Cost Name</th>
											<th class="text-center">Cost Amount (-Tax)</th>
											<th class="text-center">Ex. Rate</th>
											<th class="text-center">Tax</th>
										</tr>
									</thead>
									<tbody class="table-border-bottom-0">
										<tr v-for="(detail, index) in productCostDetail.receiving_detail_list" :key="index">
											<td class="width-40-percent p-2"><span>{{ detail.product_name }}</span></td>
											<td class="width-25-percent text-end p-2">
												{{ productCostDetail.buy_currency }} {{ formatCurrency(calculateAmount(detail)) }}
											</td>
											<td class="width-15-percent text-end p-2">{{ formatCurrency(stateData.buy_exchange_rates) }}</td>
											<td class="width-20-percent p-2">
												<span class="me-1">{{ detail.tax_buy_name_1 ? detail.tax_buy_name_1 + ": " + detail.tax_buy_value_1 + "%" : ""}}</span>
												<span class="me-1">{{ detail.tax_buy_name_2 ? ", " + detail.tax_buy_name_2 + ": " + detail.tax_buy_value_2 + "%" : ""}}</span>
												<span class="me-1">{{ detail.tax_buy_name_3 ? ", " + detail.tax_buy_name_3 + ": " + detail.tax_buy_value_3 + "%" : ""}}</span>
											</td>
										</tr>
									</tbody>
									<tfoot class="table-border-bottom-0" v-if="productCostDetail.receiving_detail_list">
										<tr>
											<td class="text-end fw-bold">Total Amount (+Tax)</td>
											<td colspan="3" class="text-center fw-bold">VND {{ formatCurrency(calculateTotalAmount(productCostDetail.receiving_detail_list)) }}</td>
										</tr>
									</tfoot>
								</table>
							</div>
						</div>
						<div class="row my-2">
							<div class="col-md-6">
								<div class="alert alert-primary" role="alert">
									<span class="alert-heading fw-bold me-3">Product Cost Amount:</span>
									<span class="fw-bold me-2">VND</span>
									<span class="fw-bold">{{ formatCurrency(productCostDetail.cost_amount * productCostDetail.buy_exchange_rates) }}</span>
									<br />
									<span class="fw-bold me-2">Payment Due Date:</span>
									<span class="fw-bold">{{ formatDate(productCostDetail.payment_due_date) }}</span>
								</div>
							</div>
							<div class="col-md-6">
								<div class="alert alert-warning" role="alert">
									<span class="alert-heading fw-bold me-2">Actual Cost Amount: </span> 
									<span class="fw-bold me-2">VND</span>
									<span class="fw-bold">{{ formatCurrency(productCostDetail.cost_actual_amount) }}</span>
									<br />
									<span class="fw-bold me-2">Actual Payment Date:</span>
									<span class="fw-bold">{{ formatDate(productCostDetail.actual_payment_date) }}</span>
								</div>
							</div>
						</div>
						<div class="col-sm-12">
							<span class="fw-bold me-2">Ramark: </span>
							<span>{{ productCostDetail.remark }}</span>
						</div>
					</div>
				</div>
				<div class="modal-footer1">
					<div class="row my-4">
						<div class="col-md-4"></div>
						<div class="col-md-4">
							<button type="button" 
								class="btn btn-outline-secondary w-100" 
								data-bs-dismiss="modal"
								@click="closeViewModal"
							>
								<i class='bx bx-arrow-back' ></i>
								Back to Detail
							</button>
						</div>
						<div class="col-md-4"></div>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
// import RiseLoader from 'vue-spinner/src/RiseLoader.vue'
// import { configs } from '@/config/calendar.js';
import { CATEGORY_PRODUCT_COST, COST_STATUS, CLOSING_TIME, PAYMENT_METHOD } from "../../config/common.js"
import { utilities } from "../../services/utilities.js";

export default {
	name: 'ProductCostReceivingViewModal',
  components: {
  },
  props: {
		"receiving_voucher_id": {
			type: Number,
			required: false
		}
  },
  emits :{
		closeProductCostReceivingViewModal: null
  },
	watch: {
		"receiving_voucher_id" (newVal) {
			if (!newVal) return;

			this.$store.dispatch('productCostReceiving/getProductCostDetailForModalByReceivingID', newVal).then(
				() => {
					this.productCostDetail = this.stateData;
					if (this.productCostDetail.category_cost != null) {
						let cate_productCost = this.categoryOptions.find(option => 
							option.id == this.productCostDetail.category_cost
						);
						this.productCostDetail.category_cost = cate_productCost.id;
						this.productCostDetail["category_cost_name"] = cate_productCost.category_name;
					}
					
					this.$store.dispatch('productCostReceiving/getSupplierInfo', this.productCostDetail.supplier_id).then(
						(response) => { 
							this.productCostDetail["supplier_information"] = response;
						},
						(error) => {
							console.log(error);
						}
					);
				},
				(error) => {
					console.log(error);
					this.productCostDetail = {};
				}
			);
		}
	},
	data() {
		return {
			today: new Date(),
			productCostDetail: {}
		}	
	},
	computed: {
		...mapState({
			stateData: state => state.productCostReceiving.stateData,
			listProucts: state => state.productCostReceiving.stateData.receiving_detail_list
		}),
		categoryOptions() {
      return CATEGORY_PRODUCT_COST;
    },
		statusOptions() {
      return COST_STATUS;
    },
		closingTimeOptions() {
			return CLOSING_TIME;
		},
		paymentMethodOptions() {
			return PAYMENT_METHOD;
		},
	},
	created() {
  },
	methods: {
		getNotifyMessage (value){
      let remaining_days = this.countRemainingDays(this.productCostDetail.payment_due_date);
      let str = remaining_days == 1 ? " day" : " days";
      let result = "";
      switch (value) {
        case 1:
        case 2:
          result = "Remaining Payment Time: " + remaining_days + str;
          break;
        case 3: 
          result = "Late Payment for " + Math.abs(remaining_days) + str;
          break;
        case 4: 
          result = "Payment has already paid";
          break;
        case 5:
          result = "Already paid, but late for " + Math.abs(remaining_days) + str;
          break;
        default:
          break;
      }
      return result;
    },
		countRemainingDays(payment_due_date) {
      if (!payment_due_date) return 0;
      let due_date = this.$moment(payment_due_date.toString());
      return due_date.diff(this.today, 'days');
    },
		getClosingTime(close_time_id) {
			if (!close_time_id) return;
      let query = this.closingTimeOptions.filter(item => item.id == close_time_id);
      return query[0].name
    },
    getPaymentName(val) {
			if (!val) return;
      let query = this.paymentMethodOptions.filter((item) => {
        return item.value == val;
      });
      return query.length > 0 ? query[0].name_en : ""
    },
		formatDate(date) {
      if (date) {
        return utilities.changeFormatDate(date);
      }
    },
    formatCurrency(amount) {
			// let currency_amount = parseFloat(amount);
      return utilities.getFormatCurrency(amount);
    },
		calculateAmount(productObject) {
			let result = 0;
      if (Object.keys(productObject).length > 0) {
				result = productObject.quantity_in * productObject.buy_price;
      }
      return result;
		},
		calculateTotalAmount(listProuctsArr) {
			let result = 0;
      if (listProuctsArr.length > 0) {
        listProuctsArr.forEach((item) => {
					result += item.buy_amount * this.productCostDetail.buy_exchange_rates;
        });
      }
			// this.total_cost_amount_with_tax = result;
      return result;
		},
		closeViewModal() {
			// this.productCostDetail = {};
			this.$emit('closeProductCostReceivingViewModal', null);
		}
	}
}
</script>

<style>
	@media (min-width: 992px) {
		#viewProductCost .modal-lg {
			--bs-modal-width: 56rem;
		}
	}
</style>